<template>
  <v-container class="pa-0 ma-0">
    <v-card outlined class="pa-4 ma-0" style="height: 380px">
      <!-- Global info-->
      <v-container class="chart-header d-flex justify-space-between pa-0 ma-0">
        <v-card-text class="pa-0 ma-0 text-body-2">
          {{ $t("salesTrend") }}
        </v-card-text>
      </v-container>
      <!-- area chart-->
      <apexchart
        v-if="hasData"
        type="area"
        height="337"
        width="100%"
        :options="chartOptions"
        :series="chartSeries"
      />
      <v-container
        v-else
        class="pa-0 ma-0 d-flex flex-column align-center justify-center"
        style="height: 337px"
      >
        <img
          :src="require('@/assets/dashboard/no-data(3).png')"
          max-width="100"
          height="100"
          contain
          class="mb-3"
        />
        <v-card-text class="text-body-2 grey--text text-center">
          {{ $t("nothing-for-render") }}
        </v-card-text>
      </v-container>
    </v-card>
  </v-container>
</template>
<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    filterChart: {
      type: Object,
      default: null,
    },
    advanceFilter: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      chartApiResponse: {},
    };
  },
  computed: {
    hasData() {
      return this.chartSeries[0].data.some((val) => val > 0);
    },
    chartCategories() {
      const values = Object.values(this.chartApiResponse || {});
      let lastSixMonths = values.slice(-6);
      return lastSixMonths.map((item) => item.label);
    },
    chartSeries() {
      const values = Object.values(this.chartApiResponse || {});
      let lastSixMonths = values.slice(-6);
      const months = lastSixMonths.map((item) => item.monthlyInvoices.sell.amount);
      return [
        {
          name: this.$t("sell"),
          data: months,
        },
      ];
    },
    chartOptions() {
      return {
        chart: {
          type: "area",
          toolbar: {
            show: false,
          },
          fontFamily: "IRANSans",
          width: "100%",
        },

        stroke: {
          curve: "smooth",
          width: 2,
        },

        colors: ["#3BF65D", "#10B981"],

        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            opacityFrom: 0.45,
            opacityTo: 0.05,
            stops: [0, 90, 100],
          },
        },

        xaxis: {
          categories: this.chartCategories,
          tickPlacement: "on",
          labels: {
            rotate: 0,
            style: {
              fontSize: "11px",
            },
            hideOverlappingLabels: false,
          },
          axisBorder: { show: false },
          axisTicks: { show: false },
        },

        yaxis: {
          labels: {
            show: true,
            style: {
              fontSize: "10px",
            },
            offsetX: this.$vuetify.rtl ? -80 : 0,
            formatter: (value) => {
              return `${this.$numberFormat(value)} ${this.$store.state.currency.name}`;
            },
          },
        },

        grid: {
          strokeDashArray: 4,
        },

        legend: {
          position: "bottom",
          horizontalAlign: "center",
        },

        tooltip: {
          y: {
            formatter(val) {
              return val.toLocaleString();
            },
          },
        },

        dataLabels: {
          enabled: false,
        },
      };
    },
  },
  watch: {
    filterChart: {
      deep: true,
      handler(newVal) {
        this.getProgressData(newVal);
      },
    },

    advanceFilter: {
      deep: true,
      handler(newVal) {
        this.getProgressData(newVal);
      },
    },
  },
  mounted() {
    this.getProgressData();
  },
  methods: {
    getProgressData(filters = {}) {
      const hasDefaultDate = !!filters?.fromDate && !!filters?.toDate;
      const Type = hasDefaultDate ? false : "year";
      let UserList = [];
      let ProductList = [];
      if (
        filters.UserList != undefined &&
        filters.UserList != null &&
        filters.UserList != []
      ) {
        UserList = filters?.UserList.map((u) => u.id);
      }
      if (
        filters.products != undefined &&
        filters.products != null &&
        filters.products != []
      ) {
        ProductList = filters?.products.map((p) => p.id);
      }
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/charts/invoice-by-month", {
          params: {
            dateType: Type,
            fromDate: filters.fromDate || null,
            toDate: filters.toDate || null,
            status: filters.sellStatus || [],
            accountIds: filters.account || [],
            branch: filters.branch || [],
            UserList: UserList || [],
            minAmount: filters.amountRange?.[0] ?? null,
            maxAmount: filters.amountRange?.[1] ?? null,
            ProductList: ProductList || [],
            productGroup: filters.productGroup || null,
            entrepot: filters.entrepot || null,
            attachment: filters.attachments || null,
            receipt: filters.Receipt || null,
            category: filters.category || null,
            minAmountTax: filters.amountRangeTax?.[0] ?? null,
            maxAmountTax: filters.amountRangeTax?.[1] ?? null,
            invoice_status: filters.status || null,
          },
        })
        .then((response) => {
          let res = response.data.data;
          app.chartApiResponse = res;
        })
        .catch((err) => {
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.chart-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}
</style>
